"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubItemsEmptyValue = void 0;
const getSubItemsEmptyValue = () => {
    return { count: 0 };
};
exports.getSubItemsEmptyValue = getSubItemsEmptyValue;
